import { createFileRoute } from '@tanstack/react-router'
import { AgentRunDetail } from '../../../modules/agent-workspace/components/agent-run-detail'

/**
 * `/agent-workspace/$runId` - the agent run-detail replay (PLAN-03). Renders the
 * original query, the planned steps as read-only tool cards with their executed
 * results, and a metadata sidebar (agent, provider, model, status, context tuple).
 * This is the audit-trail anchor an executed step's `AuditFooter` op-id links to.
 */
export const Route = createFileRoute('/_authed/agent-workspace/$runId')({
  component: AgentRunDetailRoute,
})

function AgentRunDetailRoute() {
  const { runId } = Route.useParams()
  return <AgentRunDetail runId={runId} />
}
